<template>
  <div>
    <div class="is-flex is-justify-content-space-between">
      <label class="label">Phones</label>
      <button v-show="phones.length < 4"
        class="button is-small is-primary is-light"
        :class="`is-light-btn-${$theme.name}`"
        @click="addTmpPhone">
        <span class="icon">
          <span class="mso mso-24px">
            add
          </span>
        </span>
      </button>
    </div>
    <div v-for="(assetPhone, index) in phones"
      :key="index"
      class="field has-addons">
      <div class="control">
        <span class="select">
          <select v-model="assetPhone.type"
            :class="{ 'is-invalid' : !$v.uniquePhoneType }"
            v-tippy="{ content: 'Duplicate Type', theme: 'danger', enabled: !$v.uniquePhoneType }">
            <option v-for="(type, typeIndex) in phoneTypes"
              :key="typeIndex"
              :value="type.toString()"
              @change="$v.phones.types.touch()">
              {{ typeIndex }}
            </option>
          </select>
        </span>
      </div>

      <div class="control is-expanded">
        <input class="input"
          type="text"
          v-model="assetPhone.no"
          :class="{ 'is-danger' : $v.phones.$each[index].no.$error }"
          @input="$v.phones.$each[index].no.$touch()">
        <span class="help is-danger"
          v-if="!$v.phones.$each[index].no.required">Phone number is required
        </span>
      </div>

      <p class="control">
        <button class="button has-text-gold"
          :title="[assetPhone.isDefault ? 'Default Phone' : '']"
          @click="setDefault(assetPhone)">
          <span class="icon">
            <span class="mso mso-24px"
              :class="[assetPhone.isDefault ? 'mso-fill': '']">
              star
            </span>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button has-text-danger"
          @click="removePhone(assetPhone)">
          <span class="icon">
            <span class="mso mso-24px">
              delete
            </span>
          </span>
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import { PhoneTypes } from '@/enums'
import UserValidation from '../UserValidation.js'
import phones from '@/assets/validateForms/Phones'
export default {
  name: 'UserAssetPhones',

  props: {
    phones: {
      type: Array,
      default: () => []
    },
    required: { type: Boolean, default: false },
    assetTypeName: {
      type: String | null,
      default: 'assetPhones'
    }
  },

  computed: {
    phoneTypes() {
      return PhoneTypes
    },
    existedPhoneTypes() {
      return this.phones.map((phone) => phone.type)
    }
  },
  watch: {
    phones: {
      handler() {
        this.$emit('validationChanged', this.hasAnyValidationError())
      },
      deep: true
    }
  },

  mounted() {
    this.$v.$touch()
  },

  methods: {
    addTmpPhone() {
      this.$emit('addTmpPhone')
    },
    removePhone(assetPhone) {
      this.$emit('removePhone', assetPhone)
    },
    setDefault(assetPhone) {
      this.$emit('setDefault', assetPhone, this.assetTypeName)
    },
    hasAnyValidationError() {
      return this.$v.$error || !this.$v.uniquePhoneType || this.$v.phones.$error
    }
  },
  validations() {
    const baseValidations = UserValidation.validations.entity || {}
    const phoneValidations = this.required
      ? { ...phones }
      : {
          ...baseValidations
        }
    return {
      ...phoneValidations,
      uniquePhoneType: () => new Set(this.existedPhoneTypes).size == this.existedPhoneTypes.length
    }
  }
}
</script>
